import { DEFAULT_BOARD_HEIGHT_M, DEFAULT_INSTALLATION_HEIGHTS } from "./constants";
import { suggestTrayHeight } from "./suggestTrayHeight";
import type { ReadHeight, ResolveHeights, WriteHeight } from "./types";

export const resolveHeights: ResolveHeights = ({
  boardHeights = {},
  installationHeights = {},
  trayHeights = {},
}) => {
  const levels = { ...DEFAULT_INSTALLATION_HEIGHTS, ...installationHeights };
  return {
    levels,
    boardM: (label) => (label ? boardHeights[label] : undefined) ?? DEFAULT_BOARD_HEIGHT_M,
    trayM: (trayType) => trayHeights[trayType] ?? suggestTrayHeight({ trayType, levels }),
  };
};

export const readHeight: ReadHeight = ({ stored, target }) => {
  if (target.kind === "board") return stored.boardHeights?.[target.label];
  if (target.kind === "level") return stored.installationHeights?.[target.key];
  return stored.trayHeights?.[target.trayType];
};

const withEntry = <K extends string>(
  entries: Partial<Record<K, number>> | undefined,
  key: K,
  heightM: number | null,
): Partial<Record<K, number>> => {
  const next = { ...entries } as Partial<Record<K, number>>;
  if (heightM === null) delete next[key];
  else next[key] = heightM;
  return next;
};

export const writeHeight: WriteHeight = ({ stored, target, heightM }) => {
  if (target.kind === "board")
    return { ...stored, boardHeights: withEntry(stored.boardHeights, target.label, heightM) as Record<string, number> };
  if (target.kind === "level")
    return { ...stored, installationHeights: withEntry(stored.installationHeights, target.key, heightM) };
  return { ...stored, trayHeights: withEntry(stored.trayHeights, target.trayType, heightM) as Record<string, number> };
};
